import type { Card } from '@/types';

/**
 * First-run Home rules for a learner whose shelf holds only the sample card
 * they chose in /try. Kept pure so the rules are testable without the store.
 *
 * Eligibility is strict on purpose: only cards explicitly stamped
 * cardOrigin === 'starter' count. Unknown/null historic origins are NOT
 * starter-only, so an old learner is never shown first-run copy.
 */
export function isStarterOnlyShelf(cards: Pick<Card, 'cardOrigin'>[]): boolean {
  return cards.length > 0 && cards.every((card) => card.cardOrigin === 'starter');
}

/** Home's primary-card state. 'starter' wins over 'due': the sample is a
    demonstration, so the one primary action is making the learner's own card. */
export function getHomeReturnState(
  shelfCount: number,
  starterOnly: boolean,
  totalDue: number,
): 'due' | 'clear' | 'new' | 'starter' {
  if (shelfCount === 0) return 'new';
  if (starterOnly) return 'starter';
  return totalDue > 0 ? 'due' : 'clear';
}

/** /app destination after sign-in. Always Home once onboarded; Home itself
    shows the starter-only first-run state, so a finished import lands there. */
export function getAppDestination(onboardingCompleted: boolean): string {
  return onboardingCompleted ? '/home' : '/onboarding';
}
